import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { changePassword, getProfile } from './api'
import { IProfileActions, IProfileState, ProfilePasswordFormType } from './state.types'

export const initialStateProfile: IProfileState = {
    isLoadingProfile: false,
    isLoadingPassword: false,

    profile: {
        loginName: '',
        lastName: '',
        firstName: '',
        secondName: '',
        accessLevelID: 0,
        accessLevelName: '',
        isLocked: 0,
        itemsSites: [],
        itemsAccess: [],
    },
}

/** Хранилище страницы - Мой профиль */
export const useProfile = create<IProfileState & IProfileActions>()(devtools((set) => ({
    ...initialStateProfile,

    /** Сброс хранилища, до начального состояния */
    clearStateProfile: () => {
        set(initialStateProfile)
    },

    /** Получение профиля текущего оператора */
    actionGetProfile: async () => {
        set({ isLoadingProfile: true })

        const response = await getProfile()

        if (response.status === 200 && response.data) {
            set({ profile: response.data })
        }

        set({ isLoadingProfile: false })

        return response
    },

    /** Смена пароля текущего оператора */
    actionChangePassword: async (data: ProfilePasswordFormType) => {
        set({ isLoadingPassword: true })

        const response = await changePassword(data)

        set({ isLoadingPassword: false })

        return response
    },
}), { name: 'StateProfile' }))